module.exports = __webpack_public_path__ + "static/img/bg23.0e03553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg23.jpg
// module id = 07fu
// module chunks = 1